export default __webpack_public_path__ + "static/media/noa-41.f9bd1b35.jpg";